import Action from './baseActions';

// Types

export enum NoteflowTaskActionTypes {
  LOAD_NOTEFLOW_TASKS = 'noteflow_task/load_noteflow_tasks',
  LOADING_NOTEFLOW_TASKS = 'noteflow_task/loading_noteflow_tasks',
  LOADED_NOTEFLOW_TASKS = 'noteflow_task/loaded_noteflow_tasks',
  LOADING_NOTEFLOW_TASKS_FAILED = 'noteflow_task/loading_noteflow_tasks_failed',
  UNSET_NOTEFLOW_TASKS = 'noteflow_task/unset_noteflow_tasks',
}

// Interfaces

export interface ILoadNoteflowTasksAction extends Action {
  type: NoteflowTaskActionTypes.LOAD_NOTEFLOW_TASKS;
  payload: string; // flow run id
}

export interface ILoadingNoteflowTasksAction extends Action {
  type: NoteflowTaskActionTypes.LOADING_NOTEFLOW_TASKS;
}

export interface ILoadedNoteflowTasksAction extends Action {
  type: NoteflowTaskActionTypes.LOADED_NOTEFLOW_TASKS;
  payload: {
    result: any;
    flowRunId: string;
  }
}

export interface ILoadingNoteflowTasksFailedAction extends Action {
  type: NoteflowTaskActionTypes.LOADING_NOTEFLOW_TASKS_FAILED;
}

export interface IUnsetNoteflowTasksAction extends Action {
  type: NoteflowTaskActionTypes.UNSET_NOTEFLOW_TASKS;
  payload: string; // flow run id
}

// Functions

export function loadNoteflowTasks(flowRunId: string): ILoadNoteflowTasksAction {
  return {
    type: NoteflowTaskActionTypes.LOAD_NOTEFLOW_TASKS,
    payload: flowRunId,
  }
}

export function loadingNoteflowTasks(): ILoadingNoteflowTasksAction {
  return {
    type: NoteflowTaskActionTypes.LOADING_NOTEFLOW_TASKS,
  }
}

export function loadedNoteflowTasks(result: any, flowRunId: string): ILoadedNoteflowTasksAction {
  return {
    type: NoteflowTaskActionTypes.LOADED_NOTEFLOW_TASKS,
    payload: {
      result,
      flowRunId
    }
  }
}

export function loadingNoteflowTasksFailed(): ILoadingNoteflowTasksFailedAction {
  return {
    type: NoteflowTaskActionTypes.LOADING_NOTEFLOW_TASKS_FAILED,
  }
}

export function unsetNoteflowTasks(flowRunId: string): IUnsetNoteflowTasksAction {
  return {
    type: NoteflowTaskActionTypes.UNSET_NOTEFLOW_TASKS,
    payload: flowRunId,
  }
}

export type NoteflowTaskActions =
  | ILoadNoteflowTasksAction
  | ILoadingNoteflowTasksAction
  | ILoadedNoteflowTasksAction
  | ILoadingNoteflowTasksFailedAction
  | IUnsetNoteflowTasksAction;
